import initialState from '../../store/initialState';
import {
	LOGIN_SUCCESS,
	LOGOUT_SUCCESS,
	UPDATE_USER_DETAILS,
} from '../../constants/actionTypes';

export default (state = initialState.auth, action = null) => {
	switch (action.type) {
		case LOGIN_SUCCESS:
			return {
				...action.data,
				isLoggedIn: true,
			};

		case LOGOUT_SUCCESS:
			return initialState.auth;

		case UPDATE_USER_DETAILS:
			return {
				...state,
				user: action.data,
			};

		default:
			return state;
	}
};
